import '../../common/css/style.css';

// • Реальні історії учнів, які досягли результатів
// • Відгуки батьків (текстові або відео)
// • Посилання на соцмережі, де є більше відгуків

const INSTAGRAM = 'https://www.instagram.com/mriya_st_kyiv';
const FACEBOOK = 'https://www.facebook.com/profile.php?id=61583788163622';

export const Feedbacks = () => {
  return (
    <div id="feedbacks" className="main-style">
      <div className="container-wrapper">
        <section className="container">
          <h2 className="container-title">Відгуки 💬</h2>

          <section className="container-block">
            <h3 className="container-heading">Історії наших учнів</h3>
            <p>
              🌟 Діти, які прийшли до нас без досвіду, вже за кілька місяців
              впевнено танцюють на сцені. 🎖️ Багато наших учнів здобувають
              перші нагороди на конкурсах і фестивалях — і це лише початок.
            </p>
          </section>

          <section className="container-block">
            <h3 className="container-heading">Відгуки батьків</h3>
            <p>
              👨‍👩‍👧‍👦 Батьки відзначають теплу атмосферу студії, уважне ставлення
              тренерів і помітний прогрес дітей. 📹 Текстові та відеовідгуки
              публікуємо у наших соцмережах.
            </p>
          </section>

          <section className="container-block">
            <h3 className="container-heading">Більше відгуків у соцмережах</h3>
            <ul className="feature-list">
              <li>
                📸 Instagram:{' '}
                <a href={INSTAGRAM}>Хореографічна студія «Мрія» (instagram)</a>
              </li>
              <li>
                📘 Facebook:{' '}
                <a href={FACEBOOK}>Хореографічна студія «Мрія» (facebook)</a>
              </li>
            </ul>
          </section>

          <a href="/#contacts" className="cta-link">
            Приєднатись до наших історій <span aria-hidden="true">→</span>
          </a>
        </section>
      </div>
    </div>
  );
};
